<script setup>
import TableHeaderRow from "@/components/global-themed/table/TableHeaderRow.vue";
import TableHeaderCell from "@/components/global-themed/table/TableHeaderCell.vue";
import {useTemplateFilters} from "@/composables/email-templates/useEmailTemplates";

const {orderDirection, orderBy, changeOrderBy} = useTemplateFilters();
</script>

<template>
  <TableHeaderRow>
    <TableHeaderCell
      col-span="4"
      :order-by="orderBy"
      :order-direction="orderDirection"
      name="name"
      @order-changed="changeOrderBy"
    >
      <span>Name</span>
    </TableHeaderCell>

    <TableHeaderCell
      col-span="6"
      :order-by="orderBy"
      :order-direction="orderDirection"
      name="description"
      @order-changed="changeOrderBy"
    >
      <span>Description</span>
    </TableHeaderCell>

    <TableHeaderCell col-span="2" />
  </TableHeaderRow>
</template>

